module.exports = __webpack_public_path__ + "img/be-accountable.85abfcd1.svg";